import { gen2Request } from 'src/services/gen_2_http_reqs';
import { capFirstChar } from '../utilities';
//Types
import type { Device } from 'src/types/Device';
import type { MediaResponseInterface } from 'src/types/MediaResponseInterface';

export type MediaFile = {
	id: number;
	name: string;
	image: string;
	selected: boolean;
};

/**
 * Loads media files from the device.
 * Filters the media files to include only audio files and updates the media files list.
 *
 * @async
 * @returns {Promise<MediaFile>}
 */
export const loadMediaFiles = async (device: Device): Promise<MediaFile[]> => {
	const res: MediaResponseInterface = await gen2Request(device, 'Media.List', {});
	if (res?.isok) {
		const list = res.data?.list || res.list;
		const files = list?.filter((i) => i.type === 'AUDIO') || [];
		return files.map((m) => ({
			...m,
			name: capFirstChar(m.title),
			image: m.preview,
		}));
	}
	return null;
};
